var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '~/services/service.base';
import FileSaver from 'file-saver';
import { getBaseUrl } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
export let ServiceFileSaver = class ServiceFileSaver {
    save(url, filename) {
        const [fileExtension] = url.match(/\.[^.]+$/) || [''];
        const fileName = filename.replace(/\s/g, '_') + `.${fileExtension}`;
        FileSaver.saveAs(url, fileName);
    }
    download(type, fileIds) {
        let inputs = '';
        fileIds.forEach((fileId, index) => {
            inputs = inputs + '<input type="text" name="files[' + index + ']" value="' + fileId + '">';
        });
        const inner = '<input name="type" value="files">' + inputs;
        const form = document.createElement('form');
        form.style.display = 'none';
        form.innerHTML = inner;
        form.action = `${getBaseUrl()}${EApiUrl.download}`;
        form.method = 'post';
        document.body.appendChild(form);
        form.submit();
        form.remove();
    }
};
ServiceFileSaver = __decorate([
    Injectable()
], ServiceFileSaver);
